<template>
  <div class='mb25 s_flex_ali'>
    <span class='mr15'>
      <a-button type="primary" v-has:clerkLevelCreate="()=>{type='add';visible=true}">
        <PlusOutlined />
        添加级别
      </a-button>
    </span>
    <p class="s_fonts16 s_c333 ">警告：店员级别一经启用，请不要随意修改！最多添加10个级别</p>
  </div>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:manage="{ record }">
      <span class="m-r-20">添加店员：
        <CheckOutlined v-if='record.is_can_add' />
        <CloseOutlined v-else />
      </span>
      <span>删除店员：
        <CheckOutlined v-if='record.is_can_del' />
        <CloseOutlined v-else />
      </span>
    </template>
    <template v-slot:action="{ record }">
          <a-button size="small" v-has:clerkLevelEdit="()=>{{type='edit';visible=true;itemId=record.id}}"  class="m-r-10" type="primary">修改</a-button>
          <a-button size="small" v-has:clerkLevelDel="()=>delLevel(record)" type="primary" danger>删除</a-button>
    </template>
  </a-table>
  <a-modal  :keyboard="false" :title="type=='edit'?'编辑级别':'添加级别'" :width='800' centered :footer="null" v-model:visible="visible" destroyOnClose>
    <levelAdd v-on:onsubmit='onsubmit' :type="type" :id="itemId"></levelAdd>
  </a-modal>
</template>
<script>
import {
  PlusOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getLevelList, levelDel } from "@/api/clerk";
import { iscode } from "@/utils/app";
import levelAdd from "./level_add";
let defSearch = {
  page: 1,
  limit: 10,
};
export default {
  components: {
    PlusOutlined,
    levelAdd,
    CheckOutlined,
    CloseOutlined,
  },
  name: "levelList",
  setup(props, { emit }) {
    // 列表数据和列头配置
    let data = ref([]);
    const search = ref({ ...defSearch });
    const state = reactive({
      type: "add",
      itemId:'',
      visible: false,
      listLoading: false,
      total: 1,
    });
    let columns = [
      {
        title: "店员等级",
        dataIndex: "weight",
        key: "weight",
      },
      {
        title: "店员类型",
        dataIndex: "type_name",
        key: "type_name",
      },
      {
        title: "级别名称",
        dataIndex: "level_name",
        key: "level_name",
      },
      {
        title: "需成长值达",
        dataIndex: "growth_value",
        key: "growth_value",
      },
      {
        title: "店员管理",
        dataIndex: "is_can_text",
        key: "is_can_text",
      },
      {
        title: "店员数量",
        dataIndex: "clerks_count",
        key: "clerks_count",
      },
      {
        title: "备注",
        dataIndex: "remarks",
        key: "remarks",
          customRender: ({ text,record }) => {
              return record.remarks ?record.remarks:'-'
          },
      },
      {
        title: "操作",
        key: "action",
        width:160,
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    //删除等级
    const delLevel = (e) => {
      $Modal.confirm({
        centered:true,
        title: "删除店员等级",
        content: "删除后该等级将无法恢复，您确定要删除该店员等级吗？",
        onOk: async () => {
          let res = await levelDel(e.id ).then((res) => res.data);
          if (iscode(res)) {
            message.success(res.msg);
            initData(search.value);
          } else {
            message.error(res.msg);
          }
        },
      });
    };
    const onsubmit =  (form) => {
      state.visible = false;
      initData(search.value);
      state.type == "add";
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getLevelList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    onMounted(() => {
      // 查看是否有留存状态，有则替换
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      delLevel,
      onsubmit
    };
  },
};
</script>